import { createAction } from '../../utils/helpers';
import * as actionTypes from './types';

export const fetchResetToken = createAction(actionTypes.FETCH_RESET_TOKEN);
export const fetchResetTokenSuccess = createAction(actionTypes.FETCH_RESET_TOKEN_SUCCESS);

export const updatePassword = createAction(actionTypes.UPDATE_PASSWORD);
export const updatePasswordSuccess = createAction(actionTypes.UPDATE_PASSWORD_SUCCESS);
